export default {
  // Hero section
  'hero.title': 'ਪੇਸ਼ੇਵਰ ਔਨਲਾਈਨ ਟਾਈਮਰ ਟੂਲ',
  'hero.subtitle': 'ਆਪਣੀਆਂ ਲੋੜਾਂ ਲਈ ਸੰਪੂਰਨ ਸਮਾਂ ਟੂਲ ਚੁਣੋ',

  // Tool cards
  'timer.title': 'ਟਾਈਮਰ',
  'timer.description': 'ਕੰਮ, ਪੜ੍ਹਾਈ ਅਤੇ ਜੀਵਨ ਲਈ ਉਲਟੀ ਗਿਣਤੀ ਟਾਈਮਰ',
  'timer.longDescription': 'ਉਤਪਾਦਕਤਾ, ਖਾਣਾ ਬਣਾਉਣ ਅਤੇ ਸਮਾਂ ਪ੍ਰਬੰਧਨ ਲਈ ਉਲਟੀ ਗਿਣਤੀ ਟਾਈਮਰ',
  'timer.button': 'ਟਾਈਮਰ ਸ਼ੁਰੂ ਕਰੋ',

  'stopwatch.title': 'ਸਟਾਪਵਾਚ',
  'stopwatch.description': 'ਉੱਚ-ਸ਼ੁੱਧਤਾ ਸਮਾਂ ਟੂਲ',
  'stopwatch.longDescription': 'ਖੇਡਾਂ, ਸਿਖਲਾਈ ਅਤੇ ਸਟੀਕ ਸਮਾਂ ਲਈ ਉੱਚ-ਸ਼ੁੱਧਤਾ ਸਟਾਪਵਾਚ',
  'stopwatch.button': 'ਸਟਾਪਵਾਚ ਸ਼ੁਰੂ ਕਰੋ',

  'worldclock.title': 'ਵਿਸ਼ਵ ਘੜੀ',
  'worldclock.description': 'ਦੁਨੀਆ ਭਰ ਦੇ ਸਮਾਂ ਖੇਤਰ ਦੇਖੋ',
  'worldclock.longDescription': 'ਬੁੱਧੀਮਾਨ ਸਮਾਂ ਖੇਤਰ ਗਣਨਾਵਾਂ ਦੇ ਨਾਲ ਗਲੋਬਲ ਮੁੱਖ ਸ਼ਹਿਰਾਂ ਦੇ ਸਮੇਂ ਦਾ ਰੀਅਲ-ਟਾਈਮ ਡਿਸਪਲੇ',
  'worldclock.button': 'ਵਿਸ਼ਵ ਘੜੀ ਦੇਖੋ',

  // Features section
  'features.title': 'timer.today ਕਿਉਂ ਚੁਣੋ?',
  'features.reliable.title': 'ਭਰੋਸੇਮੰਦ ਅਤੇ ਸਟੀਕ',
  'features.reliable.desc': 'ਬ੍ਰਾਊਜ਼ਰ-ਅਧਾਰਿਤ ਭਰੋਸੇਯੋਗਤਾ ਦੇ ਨਾਲ ਮਿਲੀਸਕਿੰਟ ਸ਼ੁੱਧਤਾ ਸਮਾਂ',
  'features.crossPlatform.title': 'ਕ੍ਰਾਸ-ਪਲੇਟਫਾਰਮ',
  'features.crossPlatform.desc': 'ਡੈਸਕਟਾਪ, ਟੈਬਲੇਟ ਅਤੇ ਮੋਬਾਈਲ ਡਿਵਾਈਸਾਂ ਤੇ ਸੁਚੱਜੇ ਢੰਗ ਨਾਲ ਕੰਮ ਕਰਦਾ ਹੈ',
  'features.smartNotifications.title': 'ਸਮਾਰਟ ਸੂਚਨਾਵਾਂ',
  'features.smartNotifications.desc': 'ਸਮਾਂ ਖਤਮ ਹੋਣ ਤੇ ਧੁਨੀ ਚੇਤਾਵਨੀਆਂ ਅਤੇ ਡੈਸਕਟਾਪ ਸੂਚਨਾਵਾਂ',
  'features.easyToUse.title': 'ਵਰਤਣ ਵਿੱਚ ਆਸਾਨ',
  'features.easyToUse.desc': 'ਸਾਰੇ ਉਪਭੋਗਤਾਵਾਂ ਲਈ ਸਹਿਜ ਨਿਯੰਤਰਣਾਂ ਦੇ ਨਾਲ ਸਾਫ ਇੰਟਰਫੇਸ',

  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
